import React, { useState } from 'react';
import { DropdownMenu, DropdownMenuButton, DropdownMenuItem, DropdownMenuItems, useDropdownMenu } from '@jetshop/ui/DropdownMenu';
import t from '@jetshop/intl';
import { styled } from 'linaria/react';
import { Field, connect } from 'formik';
const Label = /*#__PURE__*/styled('label')({
  name: "Label",
  class: "ldzg8x5"
});
export const PreOrderDropdown = ({
  values,
  selectedDate,
  selectDate
}) => React.createElement(DropdownMenu, null, React.createElement(DropdownMenuButton, {
  id: "pre-order-option"
}, selectedDate ? selectedDate : t.rich('Select pre-order date')), React.createElement(DropdownItems, {
  values: values,
  selectDate: selectDate
}));

const DropdownItems = ({
  values,
  selectDate
}) => {
  const {
    setIsOpen
  } = useDropdownMenu();
  return React.createElement(DropdownMenuItems, {
    style: {
      zIndex: 9999
    }
  }, values.map(value => {
    return React.createElement(DropdownMenuItem, {
      key: value.value
    }, React.createElement(PreOrderInput, {
      value: value,
      selectDate: selectDate,
      callback: () => setIsOpen(false)
    }));
  }));
};

export const PreOrderInput = ({
  value,
  selectDate = () => {},
  callback = () => {},
  className = ''
}) => React.createElement(Field, {
  name: "preOrder",
  type: "radio",
  value: value.value,
  render: ({
    field,
    form: {
      values,
      validateForm
    }
  }) => React.createElement(Label, {
    className: className
  }, React.createElement("input", Object.assign({}, field, {
    type: "radio",
    required: true,
    onChange: e => {
      field.onChange(e);
      selectDate(value.value);
      const newValues = Object.assign(Object.assign({}, values), {
        preOrder: value.value
      });
      validateForm(newValues);
      callback(value);
    }
  })), React.createElement("span", null, value.name))
});

const PreOrderDateSelector = ({
  product,
  children,
  formik,
  dates,
  SelectorComponent = PreOrderDropdown,
  intlDateTimeFormat = new Intl.DateTimeFormat('sv-SE'),
  className
}) => {
  var _a, _b, _c;

  const defaultValue = ((_a = formik === null || formik === void 0 ? void 0 : formik.values) === null || _a === void 0 ? void 0 : _a.preOrder) || '';
  const [selectedDate, selectDate] = useState(defaultValue);
  const {
    preOrder
  } = product;

  if (!preOrder) {
    console.error('The attribute `preOrder` has not been defined on the product page GraphQL fragment.');
    return null;
  }

  const {
    fromDate,
    toDate
  } = preOrder; // It is not a pre-order product

  if (!fromDate || !toDate) return null;
  if (dates) return dates;
  const dateList = [];
  const startDate = new Date(fromDate);
  const endDate = new Date(toDate); // Creating a list of all the days between fromDate and toDate

  for (let x = startDate; startDate <= endDate; x.setDate(x.getDate() + 1)) {
    const newDate = intlDateTimeFormat.format(new Date(x)).toString();
    dateList.push({
      value: newDate,
      name: newDate
    });
  }

  const values = dateList;
  return children ? children({
    values: values,
    selectedDate: selectedDate,
    selectDate: selectDate,
    error: (_b = formik === null || formik === void 0 ? void 0 : formik.errors) === null || _b === void 0 ? void 0 : _b.preOrder
  }) : React.createElement("div", {
    className: className
  }, React.createElement("label", null, t('Pre-order date')), React.createElement(SelectorComponent, {
    values: values,
    selectedDate: selectedDate,
    selectDate: selectDate
  }), ((_c = formik === null || formik === void 0 ? void 0 : formik.errors) === null || _c === void 0 ? void 0 : _c.preOrder) && React.createElement("span", null, formik.errors.preOrder));
};

export default connect(PreOrderDateSelector);

require("../../../../.linaria-cache/node_modules/@jetshop/ui/PreOrderDateSelector/PreOrderDateSelector.linaria.css");